import styled from 'styled-components';
import { typography, theme } from 'dab-component-lib';
import { MediaStyle, basic } from '../../../utils/style-utils';

export const AbsoluteContainerStyle = styled.div`
  position: fixed;
  background-color: white;
  z-index: ${theme.zIndex.overthetop};
  height: 100vh;
  width: 100vw;
  right: 0;
  top: 0;
  ${ MediaStyle.md`
    position: absolute;
    top: 60px;
    height: auto;
    width: auto;
    min-width: 320px;
    box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.4);
  ` }
`;

export const CartPanelWrapper = styled.div`
  & > div {
    height: 100vh;
    box-shadow: none;
    overflow-y: scroll;
    ${ MediaStyle.md`
      height: auto;
      overflow: auto;
    ` }
  }
  ${ MediaStyle.md`
    h3 {
      div {
        display: none;
      }
    }
    & > div > div:first-of-type {
      max-height: 400px;
      overflow-y: scroll;
    }
  `}
`;

export const EmptyTitle = styled.h2`
  ${typography.Headline1};
  color: ${basic.secondary};
  padding: 15px 15px 0;
  margin-top: 0;
`;

export const EmptyDescription = styled.p`
  ${typography.Body2};
  padding: 0 15px 15px;
  margin-bottom: 0;
`;



// WEBPACK FOOTER //
// ./src/components/common/cartMenu/style.js